import { render, staticRenderFns } from "./serviceMaterial.vue?vue&type=template&id=fa9e5954&scoped=true&"
import script from "./serviceMaterial.vue?vue&type=script&lang=js&"
export * from "./serviceMaterial.vue?vue&type=script&lang=js&"
import style0 from "./serviceMaterial.vue?vue&type=style&index=0&id=fa9e5954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9e5954",
  null
  
)

export default component.exports